//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { iosInput } from '@/tools/index.js'
import { mapGetters } from 'vuex'
import dropdownRadio from './dropdown_radio'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  mixins: [downloadImgs],
  data () {
    return {
      selectTextOne: '',
      selectValueOne: '',
      selectTextTwo: '',
      selectValueTwo: '',
      selectTextThree: '',
      selectValueThree: '',
      selectTextFour: '',
      selectValueFour: '',
      rule: {
        custom: {
          selectTextOne: {
            required: () => '请确保答案完整',
          },
          selectTextTwo: {
            required: () => '请确保答案完整',
          },
          selectTextThree: {
            required: () => '请确保答案完整',
          },
          selectTextFour: {
            required: () => '请确保答案完整',
          }
        }
      },
      selectListTwo: [],
      selectListThree: [],
      selectListFour: []
    }
  },
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number
    },
    readonly: {
      type: Boolean
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  mounted () {
    this.$validator.localize('zh_CN', this.rule);
    //已答的题挂上答案
    if (this.question.v_answer) {
      console.log(this.question.v_answer);
      //选中选项
      const ids = this.question.v_answer.currentValue
      for (var k in ids) {
        let optionObj = this.getAnsweredData(ids[k])
        if (k == 0) {
          Object.assign(this.$data, {
            selectValueOne: optionObj.v_ownId || '',
            selectTextOne: optionObj.text || ''
          })
        } else if (k == 1) {
          Object.assign(this.$data, {
            selectValueTwo: optionObj.v_ownId || '',
            selectTextTwo: optionObj.text || ''
          })
        } else if (k == 2) {
          Object.assign(this.$data, {
            selectValueThree: optionObj.v_ownId || '',
            selectTextThree: optionObj.text || ''
          })
        } else if (k == 3) {
          Object.assign(this.$data, {
            selectValueFour: optionObj.v_ownId || '',
            selectTextFour: optionObj.text || ''
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters(['questionnaireList']),
    selectListOne () {
      return this.question.options.filter((item) => {
        return item.level == '0'
      })
    },
    isShowTwo () {
      return this.selectListTwo.length
    },
    isShowThree () {
      return this.selectListThree.length
    },
    isShowFour () {
      return this.selectListFour.length
    },
    currentValue () {
      let arr = []
      arr[0] = this.selectValueOne
      this.isShowTwo && (arr[1] = this.selectValueTwo)
      this.isShowThree && (arr[2] = this.selectValueThree)
      this.isShowFour && (arr[3] = this.selectValueFour)
      return arr
    }
  },
  watch: {
    async currentValue (n ,o) {
      const param = {
        index: this.index,
        v_answered: !!n.length
      }
      let v_answer = {}
      // 设置当前题目已答
      this.$store.commit('setQuestionAnswered', param)
      if (!param.v_answered) {
        this.$store.commit('setQusstionUserAnswer', {
          index: this.index,
          v_answer
        })
        return
      }
      v_answer = this.getValue()
      console.log(v_answer);
      //挂本道题用户答案
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer
      })
    },
		selectTextOne (n) {
      if (n) {
        this.selectListTwo = this.question.options.filter((item) => {
          return item.parentId && item.parentId == this.selectValueOne
        })
      }  
    },
    selectTextTwo (n) {
      if (n) {
        this.selectListThree = this.question.options.filter((item) => {
          return item.parentId && item.parentId == this.selectValueTwo
        })
      }
    },
    selectTextThree (n) {
      if (n) {
        this.selectListFour = this.question.options.filter((item) => {
          return item.parentId && item.parentId == this.selectValueThree
        })
      }
    }
  },
  methods: {
    onBlur () {
      iosInput()
    },
    getAnsweredData (id) {
      let v = this.question.options.find((option) => {
        return id === option.tenantId
      })
      return v || {}
    },
    getValue (value) {
      let options = []
			console.log(this.currentValue);
      this.currentValue.forEach((item,index) => {
        if (item) {
          let v = this.question.options.find((option) => {
            return item === option.v_ownId
          })
          options.push({
						tenantId: v.tenantId,
						v_ownId: v.v_ownId
					})
        } else {
          options.push({
						tenantId: '',
						v_ownId: ''
					})
        }
      })
			return {
				tenantId: this.question.tenantId,
				type: 'select_mulitple',
        options: options,
        currentValue: options.map((item) => {return item.tenantId})
			}
    },
    validate () {
      return this.$validator.validateAll()
    },
    openSelectOne () {
      this.openPickerHandle(this.selectListOne,'selectValueOne','selectTextOne')
      .then(() => {
        Object.assign(this.$data, {
          selectTextTwo: '',
          selectTextThree: '',
          selectTextFour: '',
          selectValueTwo: '',
          selectValueThree: '',
          selectValueFour: '',
          selectListThree: [],
          selectListFour: []
        })
      })
    },
    openSelectTwo () {
      this.openPickerHandle(this.selectListTwo,'selectValueTwo','selectTextTwo')
      .then(() => {
        Object.assign(this.$data, {
          selectTextThree: '',
          selectTextFour: '',
          selectValueThree: '',
          selectValueFour: '',
          selectListFour: []
        })
      })
    },
    openSelectThree () {
      this.openPickerHandle(this.selectListThree,'selectValueThree','selectTextThree')
      .then(() => {
        Object.assign(this.$data, {
          selectTextFour: '',
          selectValueFour: ''
        })
      })
    },
    openSelectFour () {
      this.openPickerHandle(this.selectListFour,'selectValueFour','selectTextFour')
      .then(() => {})
    },
    openPickerHandle (list, value, text) {
      let options = list.map((item) => {
        return {
          ...item,
          id: item.v_ownId || ''
        }
      })
      let self = this
      return new Promise((resolve, reject) => {
        new this.$Picker({
          data: [options],
          value: self[text],
          title: {
            text: ''
          },
          dataValue: 'id',
          dataText: 'text',
          cascade: false,
          onOk: (values, texts, selectedIndex) => {
            self[value] = values.join('')
            self[text] = texts.join('')
            resolve()
          }
			  })
      })
    }
  }
}
